import { reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";

const UserTester = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const advancedStore = getUserAdvancedStore();
  const userId = advancedStore.currentUserId.get();
  const data = advancedStore.userData.get(userId);
  const isUserTester = reduce(() => data.isTester, false);

  return isUserTester ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={230}
      height={36}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.white}
      style={{
        border: `${3 * unitX}px solid ${colors.all.orange}`,
        borderRadius: 20
      }}
      onClick={() => {}}
    >
      <Et3Text
        text={i18n.get("TESTER")}
        fontFamily="BOLD"
        fontSize={15}
        color={colors.all.orange}
        isSpan={true}
        style={{}}
      />
    </ET3Div>
  ) : null;
});
export default UserTester;
